<template>
  <v-container class="subheading">
    <v-layout text-xs-center wrap>
      <v-spacer></v-spacer>
      <v-flex md8 text-xs-left>
        <v-card flat light>
          <v-card-title primary-title>
            <v-flex text-xs-left>
              <div class="headline mb-0">Email</div>
              <br>dipkakwani at gmail dot com
              <br>dipk at cse dot iitm dot ac dot in
            </v-flex>
          </v-card-title>
        </v-card>
        <v-card flat light>
          <v-card-title primary-title>
            <v-flex text-xs-left>
              <div class="headline mb-0">Social Media</div>
              <br>
              <a href="https://facebook.com/diptanshu.kakwani" target="_blank">Facebook</a>
              <br>
              <a href="https://twitter.com/dipkakwani/" target="_blank">Twitter</a>
            </v-flex>
          </v-card-title>
        </v-card>
        <v-card flat light>
          <v-card-title primary-title>
            <v-flex text-xs-left>
              <div class="headline mb-0">Professional</div>
              <br>
              <a href="https://linkedin.com/in/dipkakwani/" target="_blank">LinkedIn</a>
              <br>
              <a href="https://github.com/dipkakwani/" target="_blank">GitHub</a>
              <br>
              <a href="https://gitlab.com/dipkakwani/" target="_blank">GitLab</a>
            </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Contact",
  data: function() {
    return {
      //
    };
  }
};
</script>